export default __webpack_public_path__ + "static/media/profile_avatar.bc8fb8d9.svg";